import { hardware } from '@/data/index'


// for equipment checkout options
export const paidHardware = hardware.filter(item => item.price > 0)
export const freeHardware = hardware.filter(item => item.price === 0)
export const hardwareByCategory = (hardwareOptions: Hardware[]) => hardwareOptions.reduce((acc, item) => ({
    ...acc,
    [item.category]: [...(acc[item.category] || []), item],
}), {} as Record<string, Hardware[]>)

export const getById = (id: number) => hardware.find(item => item.wc_id === id)

